window.onload = function() {

  var pageTitle = document.title;
  var attentionMessage = 'Leaving already?';
  var attntion2_message = "Come Back!"
  var blinkEvent = null;

  document.addEventListener('visibilitychange', function(e) {
    var isPageActive = !document.hidden;

    if(!isPageActive){
      blink();
    }else {
      document.title = pageTitle;
      clearInterval(blinkEvent);
    }
  });

  function blink(){
    blinkEvent = setInterval(function() {
      if(document.title === attentionMessage){
        document.title = attntion2_message;
      }else {
        document.title = attentionMessage;
      }
    }, 1000);
  }
};